<template>
  <div class="bell-button-container">
    <IconButton @click="openModal" variant="ghost" icon="bell-01" size="large" shape="round" class="bell-button" />
    <div v-if="hasActionsNeeded" class="notification-dot"></div>

    <ActionsNeededModal ref="actionsNeededModalRef" @open-wants-to-apply="openWantsToApply" />

    <WantsToApplyPanel
      v-if="selectedInquiry"
      ref="wantsToApplyPanelRef"
      :inquiry="selectedInquiry"
      @closed="selectedInquiry = undefined"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue';

import { IconButton } from '@tallo/design-system';
import { ActionsNeededModal, useActionsNeeded } from '@tallo/investor/actions-needed';
import { PropertyInquiryDto } from '@tallo/investor/property';

import WantsToApplyPanel from '../../wants-to-apply/wants-to-apply-panel.vue';

const { data } = useActionsNeeded();
const actionsNeededModalRef = ref<InstanceType<typeof ActionsNeededModal>>();
const selectedInquiry = ref<PropertyInquiryDto>();
const wantsToApplyPanelRef = ref<InstanceType<typeof WantsToApplyPanel>>();

const hasActionsNeeded = computed(() => data.value.length > 0);

function openModal() {
  actionsNeededModalRef.value?.open();
}

// Opens over the Actions needed panel, as an escalation does
async function openWantsToApply(inquiry: PropertyInquiryDto) {
  selectedInquiry.value = inquiry;
  await nextTick();
  wantsToApplyPanelRef.value?.open();
}
</script>

<style scoped lang="scss">
.bell-button-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bell-button {
  background-color: #fff;
  border-radius: 50%;
  color: var(--t-color-neutral-600);
}

.notification-dot {
  position: absolute;
  top: 0.75rem;
  right: 0.875rem;
  width: 0.625rem;
  height: 0.625rem;
  background-color: var(--t-color-orange-500);
  border: 2px solid var(--t-color-neutral-white);
  border-radius: 50%;
}
</style>
